import { Observable } from 'rxjs';
import { CargaMasivaResumen, FilaResultado } from '../model/carga-masiva/carga-masiva';

/**
 * Puerto (interfaz) para operaciones de carga masiva.
 * 
 * Define el contrato que debe implementar el adaptador HTTP
 * para comunicarse con el backend de servicios.
 */
export abstract class CargaMasivaRepository {

    /**
     * Descarga el archivo Excel de errores para gestiones masivas.
     * @param filasConError Filas con error a exportar
     * @returns Observable con el Blob del archivo Excel
     */
    abstract descargarErroresGestionesMasivas(filasConError: FilaResultado[]): Observable<Blob>;

    /**
     * Descarga el archivo Excel de errores para cumplimientos masivos Sin OC.
     * @param filasConError Filas con error a exportar
     * @returns Observable con el Blob del archivo Excel
     */
    abstract descargarErroresCumplimientos(filasConError: FilaResultado[]): Observable<Blob>;
  
  /**
   * Procesa un archivo Excel para crear citas masivamente.
   * 
   * @param archivo Archivo Excel (.xls o .xlsx)
   * @returns Observable con el resumen del procesamiento
   */
  abstract crearCitasMasivamente(archivo: File): Observable<CargaMasivaResumen>;
  
  /**
   * Procesa un archivo Excel para cancelar citas masivamente.
   * 
   * @param archivo Archivo Excel (.xls o .xlsx)
   * @returns Observable con el resumen del procesamiento
   */
  abstract cancelarCitasMasivamente(archivo: File): Observable<CargaMasivaResumen>;
  
  /**
   * Procesa un archivo Excel para registrar gestiones masivamente.
   * Legacy: LectorGestiones.java / ClaseLectorExcel.LECTOR_GESTIONES_MASIVO
   *
   * @param archivo Archivo Excel (.xls o .xlsx)
   * @returns Observable con el resumen del procesamiento
   */
  abstract procesarGestionesMasivas(archivo: File): Observable<CargaMasivaResumen>;

  /**
   * Procesa un archivo Excel para registrar cumplimientos masivamente (Sin OC).
   * Legacy: LectorCumplimientosSinOC.java / ClaseLectorExcel.LECTOR_CUMPLIMIENTOS_SINOC
   *
   * @param archivo Archivo Excel (.xls o .xlsx)
   * @returns Observable con el resumen del procesamiento
   */
  abstract procesarCumplimientosMasivos(archivo: File): Observable<CargaMasivaResumen>;

  /**
   * Obtiene la URL de descarga de la plantilla.
   * 
   * @param tipo Tipo de plantilla: 'creacion' | 'cancelacion' | 'gestiones-masivas' | 'cumplimientos-sin-oc'
   * @returns URL de la plantilla
   */
  abstract getPlantillaUrl(tipo: 'creacion' | 'cancelacion' | 'gestiones-masivas' | 'cumplimientos-sin-oc'): string;

}
